import { render, staticRenderFns } from "./NavigationGroup.vue?vue&type=template&id=3be37618&scoped=true&"
import script from "./NavigationGroup.vue?vue&type=script&lang=ts&"
export * from "./NavigationGroup.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationGroup.vue?vue&type=style&index=0&id=3be37618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be37618",
  null
  
)

export default component.exports